const initialState = {
  // Adding User
  isAddingUser: false,

  // Getting User List
  isGettingUserList: false,
  userList: [],
  page: 0,
  totalResults: 0,

  // Is Blocking User
  isBlockingUser: false,

  // IS Updating User List
  isUpdatingUserList: false,

  // Is Changing USer Password
  isChangingUserPassword: false,

  // is Getting Company For User
  isGettingCompanyForUser: false,
  companiesList: [],

  // is Getting User
  isGettingUser: false,
  userDetailsList: {},

  // Is Submitting Post Production Invoice
  isSubmittingPostProductionInvoice: false,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    // Is Adding User
    case "ADD_USER_REQUEST":
      return {
        ...state,
        isAddingUser: true,
      };
    case "ADD_USER_SUCCESS":
      return {
        ...state,
        isAddingUser: false,
      };
    case "ADD_USER_ERROR":
      return {
        ...state,
        isAddingUser: false,
      };
    // Getting User List
    case "USER_LIST_REQUEST":
      return {
        ...state,
        isGettingUserList: true,
      };
    case "USER_LIST_SUCCESS":
      return {
        ...state,
        userList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingUserList: false,
      };
    case "USER_LIST_ERROR":
      return {
        ...state,
        isGettingUserList: false,
      };
    // Blocking User
    case "BLOCK_USER_REQUEST":
      return {
        ...state,
        isBlockingUser: true,
      };
    case "BLOCK_USER_SUCCESS":
      return {
        ...state,
        isBlockingUser: false,
      };
    case "BLOCK_USER_ERROR":
      return {
        ...state,
        isBlockingUser: false,
      };
    // IS Updating User List
    case "UPDATE_USER_LIST_REQUEST":
      return {
        ...state,
        isUpdatingUserList: true,
      };
    case "UPDATE_USER_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingUserList: false,
      };
    case "UPDATE_USER_LIST_ERROR":
      return {
        ...state,
        isUpdatingUserList: false,
      };
    // IS Changing User Password
    case "CHANGE_USER_PASSWORD_REQUEST":
      return {
        ...state,
        isChangingUserPassword: true,
      };
    case "CHANGE_USER_PASSWORD_SUCCESS":
      return {
        ...state,
        isChangingUserPassword: false,
      };
    case "CHANGE_USER_PASSWORD_ERROR":
      return {
        ...state,
        isChangingUserPassword: false,
      };
    // IS Getting Company For User
    case "GET_COMPANY_WITH_USER_REQUEST":
      return {
        ...state,
        isGettingCompanyForUser: true,
      };
    case "GET_COMPANY_WITH_USER_SUCCESS":
      return {
        ...state,
        isGettingCompanyForUser: false,
        companiesList: action.payload,
      };
    case "GET_COMPANY_WITH_USER_ERROR":
      return {
        ...state,
        isGettingCompanyForUser: false,
      };
    // IS Getting User
    case "GET_USER_REQUEST":
      return {
        ...state,
        isGettingUser: true,
      };
    case "GET_USER_SUCCESS":
      return {
        ...state,
        isGettingUser: false,
        userDetailsList: action.payload,
      };
    case "GET_USER_ERROR":
      return {
        ...state,
        isGettingUser: false,
      };
    // Post Production Invoice
    case "POST_DEFAULT_PRODUCTION_INVOICE_REQUEST":
      return {
        ...state,
        isSubmittingPostProductionInvoice: true,
      };
    case "POST_DEFAULT_PRODUCTION_INVOICE_SUCCESS":
      return {
        ...state,
        isSubmittingPostProductionInvoice: false,
      };
    case "POST_DEFAULT_PRODUCTION_INVOICE_ERROR":
      return {
        ...state,
        isSubmittingPostProductionInvoice: false,
      };
    default:
      return state;
  }
};

export default UserReducer;
